import { makeStyles, type Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles<Theme>(
  (theme) => ({
    tooltip: {
      ...theme.typography.paragraph14,
      padding: theme.spacing(1, 1.5),
    },
    sizeSmall: {
      ...theme.typography.paragraph12,
      padding: theme.spacing(0.75, 1),
    },
    fitContent: {
      width: 'fit-content',
      maxWidth: 'unset',
    },
  }),
  { name: 'CustomTooltip' }
);
